import type { HistorySnapshot } from './types'
import { serializeHistorySnapshot } from './snapshot'

function layerItemCounts(layers: HistorySnapshot['layers']): string {
  return layers.map((layer) => layer.items.size).join(',')
}

/** Comparación estructural rápida antes de serializar (más fiable que solo JSON). */
export function hasSceneHistoryDiff(before: HistorySnapshot, after: HistorySnapshot): boolean {
  if (before.items.size !== after.items.size) return true
  if (before.price !== after.price) return true
  if (before.collisionableItems.size !== after.collisionableItems.size) return true
  if (layerItemCounts(before.layers) !== layerItemCounts(after.layers)) return true
  return serializeHistorySnapshot(before) !== serializeHistorySnapshot(after)
}

export function shouldRecordHistoryChange(
  before: HistorySnapshot,
  after: HistorySnapshot,
): boolean {
  return hasSceneHistoryDiff(before, after)
}
